var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProperAnalytics',{attrs:{"title":"ALLY 不動産活用診断","type":"realEstate","inputClass":_vm.realEstateInput},scopedSlots:_vm._u([{key:"input",fn:function(ref){
var input = ref.input;
var calcFlg = ref.calcFlg;
return [_c('Input',{attrs:{"inputValue":input,"calcFlg":calcFlg}})]}},{key:"result",fn:function(ref){
var propertyList = ref.propertyList;
var commonInput = ref.commonInput;
return [_c('Report',{attrs:{"propertyList":propertyList,"commonInput":commonInput}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }